import { Client } from "./_clientService";

export const getUsersUnderMaintenance = async (payload: any) => {
  const { pageSize: limit, ...rest } = payload;
  const resp = await new Client({
    path: "/player/maintenance/list",
    payload: {
      limit,
      ...rest,
    },
  }).post();
  return resp;
};

export const lookupUserByExternalId = async (payload: any) => {
  const resp = await new Client({
    path: "/player/maintenance/lookup",
    payload,
  }).post();
  return resp;
};

export const toggleUserMaintenance = async (payload: any) => {
  const resp = await new Client({
    path: "/player/maintenance/toggle",
    payload,
  }).post();
  return resp;
};